<eds-rating
  [rating]="rating"
  size="small"
  [isHybrid]="isHybrid"
  [theme]="theme"
  [title]="'products.morningstar-review' | translate"
></eds-rating>

<p *ngIf="isHybrid && rating > 0" class="spacing--none">
  <eds-icon
    class="print-hidden"
    type="info"
    size="small"
    tooltipPositionDefault="bottom"
    edsTooltip
    [analyticsName]="'products.morningstar-review' | translate"
    tooltipType="large"
    tooltipBehavior="fixed"
    [tooltipContent]="'products.morningstar-tooltip' | translate"
  ></eds-icon>
</p>

<p *ngIf="showNumberOfFunds && rating > 0" class="spacing--none small">
  {{ numberOfFunds }} {{ "products.funds-in-category" | translate }}
</p>

<p *ngIf="showStarLabels && rating > 0" class="spacing--none small">
  {{ starLabel }}
</p>
